/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React, { useMemo } from 'react'
import { CompanyContact } from 'types/entities/CompanyContact'
import { collectDuplicateContactEmails } from 'utils/contacts/contactDuplicateUtils'
import EditCompanyModalContactItem from './EditCompanyModalContactItem'

interface EditCompanyModalContactListProps {
    contacts: CompanyContact[]
    onView: (contact: CompanyContact) => void
    onEdit: (contact?: CompanyContact) => void
    onDelete: (contact: CompanyContact) => void
}

const EditCompanyModalContactList = (
    props: EditCompanyModalContactListProps
) => {
    const duplicateEmails = useMemo(
        () => collectDuplicateContactEmails(props.contacts),
        [props.contacts]
    )

    if (!props.contacts.length) {
        return null
    }

    return (
        <>
            {props.contacts.map((contact) => {
                const normalizedEmail = (contact.email || '').trim().toLowerCase()
                const hasDuplicateEmail =
                    Boolean(normalizedEmail) && duplicateEmails.has(normalizedEmail)

                return (
                    <EditCompanyModalContactItem
                        key={contact.id}
                        contact={contact}
                        hasDuplicateEmail={hasDuplicateEmail}
                        onView={props.onView}
                        onEdit={props.onEdit}
                        onDelete={props.onDelete}
                    />
                )
            })}
        </>
    )
}

export default EditCompanyModalContactList
